module.exports = __webpack_public_path__ + "img/Roboto-Bold.16015edb.svg";